import { useTranslation } from "react-i18next";
import { Subscriptions as SubscriptionsFeature } from "@/partner/features/subscriptions";
import { Meta } from "@/shared/components";

export function SubscriptionsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("subscriptions.pageTitle")} pageType="Partner" />
      <SubscriptionsFeature />
    </>
  );
}
